import styled from "@emotion/styled";

const IntroWrapper = styled.section`
  background-color: ${({ bgColor }) => bgColor};
`;

export default IntroWrapper;
